import { Outlet } from "react-router-dom";
import { SealRegistrationProvider } from "./SealRegistrationContext";

export const SealRegistrationLayout = () => (
  <SealRegistrationProvider>
    <Outlet />
  </SealRegistrationProvider>
);
